import React from "react";
import { Row } from "react-bootstrap";
import ModalSkeleton from "../../atoms/ModalSkeleton/index";
import classes from "./BlogDetailModal.module.css";
import { mediaUrl } from "../../../resources/utils/helper";
import Parser from "html-react-parser";
import moment from "moment";

export const BlogDetailModal = ({
  showModal = false,
  setShowModal = () => {},
  data,
}) => {
  return (
    <ModalSkeleton
      show={showModal}
      setShow={setShowModal}
      modalStyles={classes.modal}
      // header={"View Blog"}
      headerClass={classes.header}
      showCloseIcon
      headerHeading={classes.heading}
    >
      <Row className={classes.rowContainer}>
        <div className={classes.cardContainer}>
          <div className={classes.imageContainer}>
            <img
              src={`${mediaUrl(data?.bannerImage || data?.thumbnailImage || data?.image)}`}
              alt="Card Image"
              className={classes.cardImage}
            />
          </div>

          <div className={classes.contentContainer}>
            <div className={classes.title}>
              <p className="fs-27 fw-700 maxLine2 text-color-v2">
                {data?.title}
              </p>
              {(data?.createdAt || data?.date) && (
                <p className="fs-14 fw-600 text-muted mt-1 mb-2">
                  📅 {moment(data?.createdAt || data?.date).format("MMMM D, YYYY")}
                </p>
              )}
            </div>
            <div className={` ${classes.detail}`}>
              {Parser(data?.description)}
            </div>
          </div>
        </div>
      </Row>
    </ModalSkeleton>
  );
};
